import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { push } from "connected-react-router";
import axios from "axios";
import swal from "sweetalert";
import { Button, Col, Form, FormGroup, Input, Label } from "reactstrap";
import Widget from "../../components/Widget/Widget";
import { API_TIMEOUT, NIRLABA_LEMBAGA } from "../../utils/index";

const LembagaNirlabaForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [nama, setNama] = useState("");
  const [jenis, setJenis] = useState("NGO");
  const [kontak, setKontak] = useState("");
  const [alamat, setAlamat] = useState("");
  const [keterangan, setKeterangan] = useState("");
  const [aktif, setAktif] = useState("1");

  useEffect(() => {
    if (!id) return;
    axios
      .get(NIRLABA_LEMBAGA + "/" + id, { timeout: API_TIMEOUT })
      .then((res) => {
        const row = res.data?.data?.[0];
        if (!row) return;
        setNama(row.nama_lembaga || "");
        setJenis(row.jenis_lembaga || "NGO");
        setKontak(row.kontak || "");
        setAlamat(row.alamat || "");
        setKeterangan(row.keterangan || "");
        setAktif(String(row.aktif == null ? 1 : row.aktif));
      })
      .catch((err) => alert(err));
  }, [id]);

  const simpan = (e) => {
    e.preventDefault();
    const payload = {
      nama_lembaga: nama,
      jenis_lembaga: jenis,
      kontak,
      alamat,
      keterangan,
      aktif: Number(aktif),
    };
    const req = id
      ? axios.patch(NIRLABA_LEMBAGA + "/" + id, payload, { timeout: API_TIMEOUT })
      : axios.post(NIRLABA_LEMBAGA, payload, { timeout: API_TIMEOUT });
    req
      .then((res) => {
        if (res.data?.success === 1) {
          swal("Sukses", "Data lembaga tersimpan", "success");
          dispatch(push("/admin/nirlaba/lembaga"));
        } else {
          swal("Gagal", res.data?.message || "Gagal simpan", "error");
        }
      })
      .catch((err) => swal("Gagal", err.message, "error"));
  };

  return (
    <div>
      <div className="page-top-line">
        <h2 className="page-title">{id ? "Edit lembaga" : "Input lembaga"}</h2>
      </div>
      <Widget>
        <Form onSubmit={simpan}>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Nama lembaga
            </Label>
            <Col md={8}>
              <Input value={nama} onChange={(e) => setNama(e.target.value)} required />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Jenis
            </Label>
            <Col md={8}>
              <Input type="select" value={jenis} onChange={(e) => setJenis(e.target.value)}>
                <option value="NGO">NGO</option>
                <option value="Swasta">Swasta</option>
                <option value="CSR">CSR</option>
                <option value="Yayasan">Yayasan</option>
                <option value="Gereja">Gereja</option>
                <option value="Mesjid">Mesjid</option>
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Kontak
            </Label>
            <Col md={8}>
              <Input value={kontak} onChange={(e) => setKontak(e.target.value)} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Alamat
            </Label>
            <Col md={8}>
              <Input type="textarea" value={alamat} onChange={(e) => setAlamat(e.target.value)} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Keterangan
            </Label>
            <Col md={8}>
              <Input
                type="textarea"
                value={keterangan}
                onChange={(e) => setKeterangan(e.target.value)}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Status
            </Label>
            <Col md={8}>
              <Input type="select" value={aktif} onChange={(e) => setAktif(e.target.value)}>
                <option value="1">Aktif</option>
                <option value="0">Tidak aktif</option>
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} />
            <Col md={8}>
              <Button color="primary" type="submit" className="mr-2">
                Simpan
              </Button>
              <Button
                color="secondary"
                type="button"
                onClick={() => dispatch(push("/admin/nirlaba/lembaga"))}
              >
                Batal
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </Widget>
    </div>
  );
};

export default LembagaNirlabaForm;
